import { type IconPosition, iconPositions } from "#/_packages/umbrella/integrations/umbraco/types";
import type { HeadingLevel } from "#/_packages/umbrella/types";
import { tryGetHeadingLevel } from "#/_packages/umbrella/utils";

export function tryGetIconPosition(
	value?: string | null,
	defaultPosition?: IconPosition,
): IconPosition {
	return iconPositions.includes(value as IconPosition)
		? (value as IconPosition)
		: (defaultPosition ?? "start");
}

export function tryParseInt(value?: number | string | null): number {
	if (typeof value === "number") {
		return Number.isInteger(value) ? value : 0;
	}

	if (typeof value === "string") {
		const parsed = parseInt(value, 10);
		return Number.isNaN(parsed) ? 0 : parsed;
	}

	return 0;
}

export function tryGetHeadingLevelFromString(
	value: string | null | undefined,
	defaultHeadingLevel: HeadingLevel,
): HeadingLevel {
	try {
		if (typeof value === "string") {
			const level = value
				? parseInt(value.replace("h", ""), 10)
				: defaultHeadingLevel;
			return tryGetHeadingLevel(level);
		}
	} catch (e) {
		console.error(e);
		return defaultHeadingLevel;
	}
	return defaultHeadingLevel;
}
